<template>
  <div class="booking-form__sender">
    <div class="container-fluid">
      <div class="row">
        <div class="col customer-type">
          <h3 class="label text-md">
            Sender
            <tool-tip text="Sender is the person or company who supplies the commodity to be shipped." />
          </h3>
        </div>
      </div>
      <div v-if="shipper" class="row">
        <div class="col-sm-12 col-md-12 col-lg-6">
          <div class="input-wrapper">
            <label for="name" class="label">Name</label>
            <input type="text" class="input" placeholder="Enter Name" v-model="shipper.contactName" />
          </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6">
          <div class="input-wrapper">
            <label class="label">Email</label>
            <input type="email" class="input" placeholder="Enter email" v-model="shipper.email" @blur="isValidEmail" />
            <p v-if="!isValidShipperEmail" class="text-danger text-sm">
              Please enter a valid email!
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-6">
          <div class="input-wrapper">
            <div class="flex justify-between">
              <label class="label">Phone Number</label>
              <div class="flex">
                <label class="radio-label" for="mobile">
                  <input type="radio" name="mobiletype" id="mobile" value="mobile" v-model="phoneNumberType" />
                  Mobile
                  <span></span>
                </label>
                <label class="radio-label ml-4" for="fixed">
                  <input type="radio" id="fixed" name="mobiletype" value="fixed" v-model="phoneNumberType" />
                  Fixed
                  <span></span>
                </label>
              </div>
            </div>
            <div class="">
              <vue-tel-input :preferredCountries="['Nigeria']" v-model="shipper.mobile"></vue-tel-input>
              <div v-if="isValidPhone && shipper.mobile.length > 0">
                <p class="text-red-600">Phone number must be numeric values only</p>
              </div>
              <div v-if="isValidPhoneLength && shipper.mobile.length > 0">
                <p class="text-red-600">Phone number must be 11 characters long</p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-6">
          <div class="input-wrapper">
            <div class="flex justify-between">
              <label class="label">Address</label>

              <div class="flex">
                <label class="radio-label" for="residential">
                  <input type="radio" id="residential" value="residential" v-model="addressType" />
                  Residential
                  <span></span>
                </label>
                <label class="radio-label ml-4" for="business">
                  <input type="radio" id="business" value="business" v-model="addressType" />
                  Business
                  <span></span>
                </label>
              </div>
            </div>
            <!-- <vue-google-autocomplete
              id="map2"
              ref="shipperAddress"
              :value="address.name"
              classname="input"
              placeholder="Enter address"
              :country="'ng'"
              v-on:placechanged="getAddress"
            >
            </vue-google-autocomplete> -->
            <auto-complete :customStyle="customStyle" :locationDetails="viewLocationDetails" :country="'ng'"
              placeholder="Enter Address" :value="address.name" />
          </div>
        </div>
      </div>

      <hr class="mt-3 mb-3" />

      <div class="flex justify-between">
        <p class="font-semibold">Delivery Info</p>
        <p class="text-xl">+</p>
      </div>

      <div class="row mt-3">
        <div class="col-sm-12 col-md-12 col-lg-6 px-3">
          <p class="font-semibold">How do you want us to get your shipment?</p>
          <div class="mt-3">
            <div class="flex justify-between">
              <div class="flex">
                <label class="radio-label" for="dropoff">
                  <input type="radio" name="shippingtype" id="dropoff" value="dropoff" v-model="shippingType" />
                  I want to drop off at Terminal
                  <span></span>
                </label>
                <label class="radio-label ml-4" for="pickup">
                  <input type="radio" id="pickup" name="shippingtype" value="pickup" v-model="shippingType" />
                  Pick up from address
                  <span></span>
                </label>
              </div>
            </div>
            <p v-if="shippingType == 'dropoff'" :style="{ color: '#09B78A' }" class="text-xs">
              You have chosen to drop off at a Terminal. Kindly select your preferred
              location to help us recommend Terminals closest to you.
            </p>

            <div v-show="shippingType == 'dropoff'" class="">
              <div class="mt-3">
                <div>
                  <div class="flex justify-between">
                    <p>Select Location</p>
                    <div class="">
                      <base-checkbox v-model="useLocation" label="Use my current location"
                        @change="getUserLocation($event)" />
                    </div>
                  </div>
                </div>
                <div>
                  <!-- <vue-google-autocomplete
                    :disabled="editLocation"
                    id="map3"
                    ref="locationAddress"
                    :value="lAddress.name"
                    classname="input"
                    placeholder="Enter address"
                    :country="'ng'"
                    v-on:placechanged="getLAddress"
                  >
                  </vue-google-autocomplete> -->
                  <auto-complete :customStyle="customStyle" :locationDetails="getLAddress" :country="'ng'"
                    placeholder="Enter Address" :disabled="editLocation" :value="lAddress.name" />
                  <p @click="editLocation = false" class="relative cursor-pointer changer-text">
                    Change
                  </p>
                </div>
              </div>
            </div>

            <div v-if="shippingType == 'pickup' && laterDate" class="">
              <p>Date/Time</p>
              <el-date-picker v-model="pickUpDays" :style="{ width: '447px' }" class="w-full" type="date"
                placeholder="Select Preferred Pick-up date" format="yyyy/MM/dd" value-format="yyyy-MM-dd">
              </el-date-picker>
            </div>
            <div v-if="shippingType == 'pickup'" class="">
              <base-checkbox v-model="laterDate" label="Schedule at a later date" />
            </div>
          </div>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-6">
          <div class="input-wrapper" style="width: 95%">
            <base-checkbox v-model="shipper.sendShippingUpdates"
              label="Send me status updates regarding my shipment with the email provided." />
          </div>
        </div>
      </div>
      <div class="button-wrapper">
        <p class="mt-4 cursor-pointer underline" @click="$router.go(-1)">Cancel</p>
        <span class="mr-6">
          <base-button text="Continue" :loading="isLoading" @click="handleSubmit"
            :disabled="isValidPhone || isValidPhoneLength" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import isNumber from "@/mixins/isNumber";
// import VueGoogleAutocomplete from "vue-google-autocomplete";
export default {
  name: "shipper-form",
  props: ["formNo"],
  components: {
    // VueGoogleAutocomplete,
  },
  data() {
    return {
      isLoading: false,
      laterDate: false,
      shipper: {
        email: "",
        type: "",
        mobile: "",
        country: "",
        address: "",
        contactName: "",
        zipCode: 20194,
        sendShippingUpdates: false,
        dropOffLocation: {},
        dropOff: null,
      },
      pickUpDays: new Date(),
      shippingType: "",
      address: {
        name: "",
        lat: 0.0,
        lng: 0.0,
        adm_1: "",
        adm_2: "",
        locality: "",
      },
      lAddress: {
        name: "",
        lat: 0.0,
        lng: 0.0,
        adm_1: "",
        adm_2: "",
        locality: "",
      },
      addressType: "business",
      phoneNumberType: "mobile",
      countries: ["Nigeria"],
      isValidShipperEmail: true,
      isValidShipperNumber: true,
      hasCity: true,
      hasState: true,
      showModal: false,
      mustUpdate: false,
      takeOffArray: [],
      editLocation: true,
      useLocation: false,
    };
  },
  watch: {
    laterDate(val) {
      if (!val) this.pickUpDays = new Date()
    },
    "shipper.customerType"(val) {
      if (val == "business") {
        this.addressType = "business";
      } else {
        this.addressType = "residential";
      }
    },
    "shipper.mobile"(val) {
      if (val?.length <= 11) {
        this.shipper.mobile = val;
      } else {
        // this.shipper.mobile = val.trim().substring(0, 13);
      }
    },
    "$store.state.bookingModule.lastCompletedFormNo"() {
      if (this.$store.state.bookingModule.lastCompletedFormNo == this.formNo) {
        if (this.$store.getters.shipperInformation.id.length > 0) {
          this.shipper = { ...this.$store.getters.shipperInformation };
        }
      }
    },
    shipper: {
      handler: function () {
        this.mustUpdate = true;
      },
      deep: true,
    },
    shippingType(val) {
      this.getTerminals();

      this.$store.dispatch("saveBookingInformation", {
        property: "shipperShipmentType",
        value: val,
      });
      if (val == "dropoff") {
        this.lAddress = this.address;
      } else {
        this.shipper.dropOff = null;
      }
    },
    shipperDetails: {
      handler(val) {
        if (val && this.$store.getters.shipperLocationPreselected) {
          this.shipper = { ...val };
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    if (this.$store.getters.shipperLocationPreselected) {
      this.shipper = {
        ...this.$store.getters.shipperInformation,
      };

      // this.$refs.shipperAddress.update(this.formatAddress(this.shipper.address));

      this.address = this.shipper.address;

      this.getTerminals();

      delete this.shipper.userId;
      delete this.shipper.updatedAt;
      delete this.shipper.createdAt;
    }

    if (this.$route.query.type == "ships") {
      let userObj = this.$store.state.authentication.user;

      let locationObj = userObj.Org.locations.find(
        (x) => x.locationManager == userObj.id
      );

      this.shipper.contactName = userObj.Org.companyname;
      this.shipper.email = userObj.email;
      let address = {
        lat: locationObj.lat,
        lng: locationObj.long,
        name: locationObj.address,
      };

      this.shipper.address = address;
      this.shipper.mobile = userObj.mobile_no;

      this.$refs.shipperAddress.update(this.formatAddress(address));
    }
  },
  computed: {
    customStyle() {
      return {
        width: '100%',
        padding: '8px 10px',
        borderRadius: '5px',
        border: '1px solid grey'
      }
    },
    isValidPhone() {
      let phone = this.shipper.mobile;
      var patt = /[a-z]+/i;

      return patt.test(phone);
    },
    isValidPhoneLength() {
      return this.shipper.mobile.replace(/\s+/g, "").length != 11 ? true : false;
    },

    shipperDetails() {
      return this.$store.getters.shipperInformation;
    },
  },
  mixins: [isNumber],
  methods: {
    formLoaded(event) {
      event;
      this.$emit("change-form");
    },
    handleSubmit() {
      let shippingmethod = this.shippingType == "dropoff" ? 'terminal' : 'door'
      this.$store.dispatch("set3PLShippingMethodStart", shippingmethod)

      if (this.shipper.id && !this.mustUpdate) {
        this.mustUpdate = false;
      } else {
        this.submitShipperInformation();
      }
    },
    async submitShipperInformation() {
      this.shipper.address = this.address;
      try {
        this.isLoading = true;
        let payload = {
          contactName: this.shipper.contactName,
          email: this.shipper.email,
          mobile: this.shipper.mobile,
          customerType: this.shipper.customerType,
          type: this.shippingType,
          address: this.shipper.address,
          zipCode: this.shipper.zipCode,
          sendShippingUpdates: this.shipper.sendShippingUpdates,
          mobileNumberType: this.shipper.mobileNumberType,
          addressType: this.shipper.addressType,
          pickUpDays: this.pickUpDays ? this.pickUpDays : undefined,
        };

        const response = await this.$_submitShipperInformation(payload);

        this.$store.dispatch("saveBookingInformation", {
          property: "shippingInformation",
          value: response.data.data.shipping,
        });

        this.isLoading = false;
        this.handleResponse(response);
      } catch (error) {
        this.handleError(error);
        this.isLoading = false;
      } finally {
        this.isLoading = false;
      }
    },
    handleResponse(response) {
      this.isLoading = false;
      this.$store.dispatch("saveBookingInformation", {
        property: "shipper",
        value: response.data.data.location,
      });
      this.getUserPaymentSettings(response.data.data.location.userId);
      // this.createShippingId();

      // this.shipper = response.data.data.location;
      this.mustUpdate = false;

      this.$store.dispatch("saveTakeOffLocationId", response.data.data.location.id);
      this.$store.dispatch("saveLastCompletedFormNo", 1);
      this.isLoading = false;
      this.showModal = true;

      this.$emit("change-form");
    },
    async getUserPaymentSettings(userId) {
      try {
        const response = await this.$_getUserPaymentSettings(userId);

        this.$store.dispatch("saveBookingInformation", {
          property: "userPaymentSettings",
          value: response.data.paymentSettings,
        });
      } catch (error) {
        this.handleError(error);
      }
    },

    async createShippingId() {
      const payload = {
        payload: {
          shipperLocationId: this.$store.getters.shipperInformation.id,
          orgId: this.$store.state.authentication.organizationId,
          paymentStatus: "Not paid",
          dropOff: this.shipper.dropOff,
          deliveryConfirmation: false,
          currentStep: 1,
        },
      };
      if (this.consolidationId) {
        payload.payload.consolidationId = this.consolidationId;
      }
      await this.$_createShippingId(payload)
        .then((response) => {
          this.$store.dispatch("saveShippingId", response.data.data.shipping.id);

          this.$emit("change-form");
        })
        .catch((e) => {
          this.handleError(e);
        });
      this.isLoading = false;
    },

    getAddress(addressData) {
      this.address.name = addressData.route;
      this.address.lat = addressData.latitude;
      this.address.lng = addressData.longitude;

      if (!this.useLocation) {
        this.getLAddress(addressData);
      }

      this.getTerminals();
    },
    viewLocationDetails(response) {
      this.address.name = response.formatted_address;
      this.address.lat = response.geometry.location.lat();
      this.address.lng = response.geometry.location.lng();
      this.getLAddress(response)
    },
    getLAddress(response) {
      this.lAddress.name = response.formatted_address;
      this.lAddress.lat = response.geometry.location.lat();
      this.lAddress.lng = response.geometry.location.lng();

      this.getTerminals();
    },
    async getUserLocation(event) {
      if (!event) return;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          successCallback.bind(this),
          errorCallback
        );
      } else {
        console.log("Geolocation is not supported by this browser.");
      }
      function successCallback(position) {
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        this.shipper.address = {
          lat: latitude,
          lng: longitude,
        };

        this.address = {
          lat: latitude,
          lng: longitude,
        };
      }

      function errorCallback() {
        this.handleError("Error getting location");
      }
    },
    isValidEmail() {
      this.isValidShipperEmail = this.validateEmail(this.shipper.email);
    },
    async getTerminals() {
      let shipperAdd = this.address;

      const payload = {
        orgId: this.$store.state.authentication.organizationId,
        arrivalLocation: {
          lat: 0,
          lng: 0,
        },
        takeOffLocation: {
          lat: shipperAdd.lat,
          lng: shipperAdd.lng,
        },
      };

      try {
        const response = await this.$_getTerminals(payload);

        this.takeOffArray = response.data.data.takeOffLocation;
        this.pickUpArray = response.data.data.arrivalLocation;

        this.shipper.dropOff = this.takeOffArray[0].id;

        this.$store.dispatch("saveTakeOffTerminals", this.takeOffArray);
        this.$store.dispatch("savePickUpTerminals", this.pickUpArray);
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.booking-form__sender {
  padding: 2rem 2.5rem;
}

.label {
  color: var(-primaryblue);
  font-size: 0.9rem;
  font-weight: 500;
}

.check-label {
  font-size: 0.9rem;
}

.input,
.vti__input,
.vue-tel-input {
  background: #fbfcfe;
  border: 1px solid #dae8f6;
  box-sizing: border-box;
  border-radius: 2px;
  height: 2.65rem !important;
}

.input::placeholder {
  color: #bec4d5;
}

.customer-type {
  margin: 1rem 1.5rem;
}

.input-wrapper {
  width: 90%;
  margin: 0 auto 2rem;
}

.customer-type h3 {
  font-size: 1.2rem;
}

.radio-label span::after {
  background: #bec4d5;
}

.changer-text {
  top: -35px;
  right: -240px;
  width: inherit;
  text-align: center;
  color: #0038ff;
}
</style>
